<template>
  <div class="courses">
    <div class="container result-tit">
      共搜到与“<span class="kw">{{ keyword }}</span
      >”相关的 {{ total }} 个结果
    </div>
    <div v-loading="loading">
      <div v-if="!total" class="no-course">
        <i class="iconfont iconmhweikong"></i>
        <div>暂无课程</div>
      </div>
      <div>
        <div class="list-wrap">
          <div class="container" v-if="total1">
            <div class="subresult-tit">已认定课程 ({{ total1 }}) 门</div>
            <div class="course-list">
              <el-row :gutter="32">
                <el-col
                  :xs="12"
                  :sm="6"
                  v-for="(item, index) in courses"
                  :key="index"
                >
                  <div
                    class="course-item card-shadow has-hover can-click hover-bigger"
                    :class="{ first: index === 0 }"
                    @click="viewCourse(item, 1, 1)"
                  >
                    <div class="cover-wrapper">
                      <!-- <div
                        class="course-level"
                        :class="'level-' + affItem.level"
                        v-for="affItem in item.affirmCourseList"
                        :key="affItem.id"
                      >
                        {{ levelMap[affItem.level] }}
                      </div> -->
                      <div class="course-level" :class="'level-' + item.affirmCourseList[0].level">{{ levelMap[item.affirmCourseList[0].level] }}</div>
                      
                      <el-image class="cover" fit="cover" :src="buildResourcePath(item.cover)">
                        <div slot="error" class="default-img">
                          <i class="iconfont iconjiaocaizhanwei"></i>
                        </div>
                      </el-image>
                    </div>
                    <div class="course-info">
                      <h1 class="name">{{ item.name }}</h1>
                      <div class="creator">
                        <span class="teacher-academy">{{ item.orgName }}</span>
                        <span class="teacher-name">{{ item.masterName }}</span>
                      </div>
                    </div>
                  </div>
                </el-col>
              </el-row>
              <el-pagination
                @current-change="handleCurrentChange1"
                :current-page.sync="currentPage1"
                :page-size="pageSize"
                layout="prev, pager, next, jumper"
                :total="total1"
                :hide-on-single-page="true"
              ></el-pagination>
            </div>
          </div>
          <div class="contianer-box"></div>
          <div class="container" v-if="total2">
            <div class="subresult-tit">在线课程 ({{ total2 }}) 门</div>
            <div class="course-list">
              <el-row :gutter="32">
                <el-col
                  :sm="6"
                  v-for="(cItem, index) in courses1.list"
                  :key="cItem.id"
                >
                  <div
                    class="course-item card-shadow has-hover can-click hover-bigger"
                    :class="{ first: index === 0 }"
                    @click="viewCourse(cItem, sortItem, 2)"
                  >
                    <div class="cover-wrapper">
                      <div
                        class="course-level"
                        :class="'level-' + affItem.level"
                        v-for="affItem in cItem.affirmCourseList"
                        :key="affItem.id"
                      >
                        {{ levelMap[affItem.level] }}
                      </div>
                      <el-image
                        class="cover"
                        fit="cover"
                        :src="buildResourcePath(cItem.cover)"
                      ></el-image>
                    </div>
                    <div class="course-info">
                      <h1 class="name">{{ cItem.name }}</h1>
                      <div class="creator">
                        <span class="teacher-academy">{{ cItem.orgName }}</span>
                        <span class="teacher-name">{{ cItem.masterName }}</span>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="course-info">
                    <h1 class="name">{{ item.name }}</h1>
                    <div class="creator">
                      <span class="teacher-academy">{{ item.orgName }}</span>
                      <span class="teacher-name">{{ item.masterName }}</span>
                    </div>
                  </div> -->
                </el-col>
              </el-row>
              <el-pagination
                @current-change="handleCurrentChange2"
                :current-page.sync="currentPage2"
                :page-size="pageSize"
                layout="prev, pager, next, jumper"
                :total="total2"
                :hide-on-single-page="true"
              ></el-pagination>
            </div>
            <!-- <div class="more-course" @click="moreCourse">更多搜索结果</div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { spocCourses ,spocSchoolLevel} from "@/api/api.js";
import util from '@/libs/util.js'
export default {
  name: "courses",
  props: ["keyword"],
  data() {
    return {
      orgs: [],
      activeName: "0",
      currentPage1: 1,
      currentPage2: 1,
      pageSize: 8,
      total:0,
      total1:0,
      total2:0,
      courses:null,
      courses1:null,
      loading: false,
      declareTypeNavMap: {
        1: "线上课程",
        3: "混合式课程",
        4: "社会实践课程",
        5: "虚拟仿真课程",
        2: "线下课程",
      },
      typeArr: [1,3,4,5,2],
      levelMap: {
        1: "国家级",
        2: "省级",
        3: "校级",
      }
    };
  },
  created() {
    this.getCourseList();
  },
  watch: {
    $route() {
      //监听路由是否变化，激活对应菜单
      this.getCourseList();
    }
  },
  methods: {
    buildResourcePath: util.buildResourcePath,
    getCourseList() {
      this.total = 0;
      this.loading = true;
      spocCourses({
        declareType: 0,
        // type: this.activeName,
        queryKey: this.keyword,
        pn: this.currentPage1,
        ps: this.pageSize
      })
        .then(res => {
          // 返回数据
          console.log(res);
           if(res.total==undefined){
            this.total1=0
          }
          this.total1 = parseInt(res.total);
          this.courses = res.list;
          spocSchoolLevel({
           declareType: 1,
          // type: this.activeName,
          queryKey: this.keyword,
          pn: this.currentPage2,
          ps: this.pageSize
        })
          .then(res => {
            // 返回数据
            console.log(res);
          if(res.result.total==undefined){
            this.total2=0
          }else{
            this.total2 =parseInt(res.result.total);
          }
           this.total=this.total1+this.total2
           this.courses1=res.result
            this.loading = false;
          })
          .catch(err => {
            // 异常情况
            console.log(err);
            this.loading = false;
          });
        })
        .catch(err => {
          // 异常情况
          console.log(err);
          this.loading = false;
        });
     
     
    },
    handleCurrentChange1() {
      this.getCourseList()
    },
    handleCurrentChange2() {
      this.getCourseList()
    },
    handleClick() {
      this.getCourseList();
    },
    handleTypeChange(val) {
      this.currentType = val === 0 ? null : val;
      this.getCourseList();
    },
    viewCourse(item, declareType, type) {
      if(declareType == 5){
        window.open(item.url);
      } else if (type == 1) {
        this.$router.push(`/hnkc/courseContent/${declareType}/${item.id}`)
      } else {
        this.$router.push(`/hnkc/schoolLevelContent/${declareType}/${item.id}`)
      }
    },
    moreCourse() {
      
    }
  }
};
</script>

<style scoped>
h1 {
  font-weight: normal;
  margin-bottom: 24px;
  font-size: 22px;
  line-height: 24px;
  color: #111;
}
/* .courses{
  background-color: #f7f7fe;
} */
.result-tit {
  padding-top: 30px;
}
.result-tit .kw {
  color: #7691ff;
}
.list-wrap {
  padding: 30px 0 1px;
  background-color: #fff;
}
.list-wrap:nth-of-type(2n) {
  background-color: #f7f7fe;
}
.subresult-tit {
  margin-bottom: 20px;
  line-height: 26px;
  font-size: 18px;
  font-weight: bold;
}
.more-course {
  width: 244px;
  line-height: 20px;
  padding: 10px;
  margin: 0 auto 30px;
  text-align: center;
  color: #888;
  font-size: 14px;
  border: 1px solid #dadada;
  border-radius: 2px;
  cursor: pointer;
}

.course-list {
 overflow: hidden;
}

.course-item {
  margin-bottom: 30px;
  background-color: #fff;
}

.course-item .cover-wrapper {
  position: relative;
  padding-bottom: 56.25%;
}

.cover-wrapper .course-level {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 2;
  padding: 2px 4px;
  line-height: 20px;
  color: #fff;
  font-size: 14px;
  border-radius: 2px;
}
.course-level.level-1 {
  background-color: #009900;
}
.course-level.level-2 {
  background-color: #f99e16;
}
.course-level.level-3 {
  background-color: #50a6ff;
}

.cover-wrapper .cover {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #eee;
}

.course-item .course-info {
  padding: 11px 10px;
}

.course-item .name {
  height: 24px;
  line-height: 24px;
  font-size: 15px;
  margin-bottom: 10px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.course-item .creator {
  margin-top: 8px;
  height: 22px;
  line-height: 22px;
  font-size: 12px;
  color: #888;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.course-item .teacher-name {
  vertical-align: middle;
  max-width: 40%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.course-item .teacher-academy {
  float: right;
  max-width: 50%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.no-course {
  text-align: center;
  padding: 60px 10px;
  color: #999;
}
.no-course .iconfont {
  display: inline-block;
  font-size: 60px;
  margin-bottom: 20px;
  color: #ddd;
}

@media (max-width: 767px) {
  .course-list {
    margin-top: 6px;
  }

  .course-item {
    position: relative;
    margin-bottom: 0;
    padding: 14px 0;
    background-color: unset;
    border-top: 1px solid #eee;
  }

  .course-item.first {
    border-top: unset;
  }

  .course-item .cover-wrapper {
    position: absolute;
    width: 142px;
    height: 80px;
    padding-bottom: unset;
  }

  .course-item .course-info {
    min-height: 80px;
    padding: 0 10px 0 154px;
  }

  .course-item h1 {
    height: 40px;
    line-height: 20px;
    font-size: 14px;
  }

  .course-item .creator {
    margin-top: 24px;
    height: 16px;
    line-height: 16px;
    font-size: 12px;
    color: #888;
  }
}
</style>
